import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import _ from "lodash";
import { graphql, compose } from "lib/apolloClient";
import { useApolloClient } from "@apollo/client";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { goToRelativeRoute } from "modules/Services";
import classes from "./EventDetails.scss";
import I18nHOC from "UIComponents/I18nHOC";
import AnimateHeight from "UIComponents/AnimateHeight";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import TimeSelectorV2 from "UIComponents/TimeSelectorV2";
import withLoader from "UIComponents/GqlWithLoader";
import AttachmentList from "AppComponents/Attachment/AttachmentList";
import { DeleteEventButton } from "MyCalendar/components/EventModalV2/components/EventActionButton";

import {
  CloseOutlined,
  DeleteOutlined,
  CopyOutlined,
  PencilOutlined,
  ChevronDownOutlined,
} from "@toddle-edu/ds-icons";

import { colors } from "Constants";
import {
  isUserTypeStaff,
  getStringAutoLinks,
  onEnterOrSpaceKeyDown,
  getStyleStrippedText,
} from "Utils";
import {
  IconButton,
  Avatar,
  Button,
  Tooltip,
  Dialog,
  DatePicker,
  DSProvider,
} from "@toddle-edu/ds-web";
import {
  getEventMetadata,
  getTransformedEventData,
  getEventDetails,
  isViewOnlyTagMemoize,
  getRandomColorForAvatar,
  isProjectTypeIAOrEA,
  isAdminForAllCalendarModules,
  isStaffAdminForSchoolCalendarByContext,
  isStaffAdminForProject,
  END_PICKER_START_TIME,
  END_PICKER_END_TIME,
  isStaffAdminForProjectModules,
  canEditIaOrEaDeadlineMemoize,
  getCalendarEventsViewSettingValue,
  getDateLabel,
  getGradesMemoize,
  getGradeNamesMemoize,
  getDescriptionForDisplay,
  getEventDateTextMemoized,
  isNewEventCreationFlowEnabled,
  getUserEventCreationAccessLevel,
  getIsHolidayOrWholeSchoolEvent,
  isRecurringSchoolCalendarEventActionsEnabled,
  getEndType,
  getRefetchFunctionForQuery,
  getSelectedAcademicYearForSchool,
  isNewParticipantSelectorEnabled,
  isBigOrgFFEnabledAndStaffUser,
} from "MyCalendar/modules/Utils";
import {
  getCurriculumProgramFreeStatus,
  getIsCurrentAcademicYear,
} from "Platform/modules/PlatformModule";
import {
  isMasterCalendarV1Enabled,
  isMasterCalendarV2Enabled,
  deleteSchoolCalendarEvent,
  editSchoolCalendarEvent,
  updateEventModalV2,
} from "MyCalendar/modules/MyCalendarModule";
import {
  getOrganizationDetailsQuery,
  getCalendarEventAssociatedEntitiesQuery,
  getCalendarEventAssociatedEntitiesQueryV2,
  getCalendarEventsDataQuery,
  getCalendarEventsParticipantDataQuery,
} from "MyCalendar/modules/MyCalendarQuery";
import { getCalendarEventDetailsEnhancer } from "MyCalendar/modules/Enhancer";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import {
  EDIT,
  DUPLICATE,
  PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
  PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
  PENDING,
  COMPLETED,
  PROJECT_DEADLINE_REMINDER,
} from "Constants/stringConstants";

import EventCreationModal from "MyCalendar/components/EventCreationModal";
import EventParticipantList from "./components/EventParticipantList";
import ActionsDropdown from "./components/ActionsDropdown";
import { useIsCalendarInUserScope } from "MyCalendar/hooks";

import {
  updateDeadlineItem,
  deleteDeadlineItem,
  isIEAssessment,
  getSubmissionStatusLabelDetails,
} from "Projects/modules/ProjectModules";

import {
  getDefaultStudentNameOrderPreference,
  getNextOrLastAcademicYearEndDate,
  getIsStaff,
  getIsParent,
  getSelectedAcademicYearStartDate,
  getSelectedAcademicYearEndDate,
  getOrganizationCurriculumPrograms,
} from "modules/CommonSelectors";

import {
  formatDate,
  getDateMomentObjectCustom,
  getDateMomentObject,
  formatDateAsUtc,
  checkIsDateAfter,
  getISOString,
} from "Utils/DateTimeHelpers";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import {
  getProjectGroups,
  getSubText,
  getSummaryText,
} from "MyCalendar/modules/Selector";
import { updateNavigationObject } from "modules/NavigationModule";
import { getUserCoursesFromCache } from "Teacher/modules/TeacherGraphqlHelpers";
import { getUserCoursesVars } from "Course/modules/CourseModule";
import { getProjectGroupCategoryIdByType } from "Teacher/routes/Projects/modules/Utils";
import CreateCalendarDeadlineModal from "Projects/components/CreateCalendarDeadlineModal";
import moment from "moment";
import {
  deleteDeadlineV2,
  updateDeadlineV2,
} from "Projects/routes/DeadlinesV2/modules/DeadlinesV2Modules";
import EventUpdateConfirmationModal from "../EventModalV2/components/EventUpdateConfirmationModal";
import { getUserCoursesQuery } from "Teacher/modules/TeacherQuery";
import {
  TYPENAME_MAPPING,
  ENTITY_TYPE_MAPPING,
  setValue,
} from "MyCalendar/components/EventModalV2/modules/Utils";
import RecurrenceConfirmationModal from "../EventModalV2/components/RecurrenceConfirmationModal";
import EventDetailsLoader from "MyCalendar/components/EventDetails/components/EventDetailsLoader";
import { getSelectedSchoolDetailsForCalendar } from "../../modules/Utils";
import StudentAlerts from "AppComponents/StudentAlerts/StudentAlerts";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import ParticipantsSummary from "../ParticipantsSummary/ParticipantsSummary";

const initialEventCreationModalObj = {
  isVisible: false,
  eventType: null,
  action: null,
  isDeadlineAllDay: true,
};

const styles = {
  timeSelectorDropdownContainerStyle: {
    top: "-11px",
    left: "-1px",
    width: "128px",
    position: "absolute",
  },
  timeSelectorDropdownItemStyle: {
    display: "flex",
    width: "100%",
  },
  timeSelectorInputStyle: {
    border: "none",
    height: "24px",
    padding: "4px 8px",
    fontWeight: "500",
    fontSize: "1.4rem",
    color: colors.textDefault,
    textAlign: "center",
    pointerEvents: "none",
  },
  timeSelectorTimeComponentStyle: {
    padding: "0",
    height: "unset",
    width: "84px",
    backgroundColor: "var(--surface-primary-active)",
    zIndex: "0",
    borderRadius: "4px",
  },
  timeSelectorDropdownParentContainerStyle: {
    width: "100%",
  },
  avatarStyles: {
    size: "small",
    color: "neutral",
    shape: "circle",
    iconType: "none",
    shade: "light",
    randomizeColor: true,
  },
  timeSelectorContainerStyle: {
    width: "unset",
  },
  iconButtonCustomStyles: { height: "fit-content", padding: "8px" },
  attachmentContainerStyle: { gridGap: "8px" },
};

const DIALOGUES_INFO = {
  PROJECT_DEADLINE: {
    title: t => t("project:delete_deadline_confirmation"),
    body: ({ t, isEventCreatedByTheCurrentUser, name }) =>
      isEventCreatedByTheCurrentUser
        ? t("project:delete_deadline_message")
        : t("common:delete_msg_with_label_and_creator", {
            label: t("common:deadline"),
            creatorName: name,
          }),
    confirmButtonText: t => t("common:delete"),
    cancelButtonText: t => t("common:cancel"),
  },
  SCHOOL_CALENDAR_EVENT: {
    title: t =>
      t("common:delete_with_label", {
        label: t("announcement:calendar_event"),
      }),
    body: ({ t, isEventCreatedByTheCurrentUser, name }) =>
      isEventCreatedByTheCurrentUser
        ? t("common:delete_msg_with_label", {
            label: t("announcement:calendar_event"),
          })
        : t("common:delete_msg_with_label_and_creator", {
            label: t("announcement:calendar_event"),
            creatorName: name,
          }),
    confirmButtonText: t => t("common:delete"),
    cancelButtonText: t => t("common:cancel"),
  },
};

const CalendarUnifiedLabelGrade = React.memo(props => {
  const { t, gradeNamesList, filteredGrades } = props;
  const firstGrade = _.first(gradeNamesList);
  const totalGrades = _.size(gradeNamesList);
  const totalStudents = _.reduce(
    filteredGrades,
    (total, grade) => {
      return total + _.get(grade, "studentCount", 0);
    },
    0
  );

  return totalGrades > 1 ? (
    <div className={classes.title}>{`${t("common:grade_with_count_lowercase", {
      count: totalGrades,
    })} | ${t("common:student_count", { count: totalStudents })}`}</div>
  ) : (
    <div className={classes.title}>{`${firstGrade}`}</div>
  );
});

CalendarUnifiedLabelGrade.displayName = "CalendarUnifiedLabelGrade";

const CalendarWiseAssignedGrades = React.memo(props => {
  const { t, filteredGrades, gradeNamesList, isStaff, testId } = props;
  const [isCourseGradesVisible, setisCourseGradesVisible] = useState(false);

  const arrowIconStyle = classNames(
    { [classes.arrowIcon]: true },
    { [classes.arrowIconReversed]: isCourseGradesVisible }
  );

  const showStudentHandler = () => {
    if (isStaff) setisCourseGradesVisible(state => !state);
  };

  const handleKeyDown = event => {
    onEnterOrSpaceKeyDown(event, showStudentHandler);
  };

  return (
    <div className={classes.courseDetails}>
      <div
        className={classes.courseDetailsHeader}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        onClick={showStudentHandler}
      >
        <div className={classes.left}>
          <div className={classes.assignedToLabel}>{`${t(
            "common:invited"
          )}`}</div>
          <div className={classNames("text-body", classes.courseSummary)}>
            <CalendarUnifiedLabelGrade
              t={t}
              gradeNamesList={gradeNamesList}
              filteredGrades={filteredGrades}
            />
          </div>
          <AnimateHeight
            height={isCourseGradesVisible ? "auto" : 0}
            duration={300}
            onAnimationStart={null}
            onAnimationEnd={null}
            animateOpacity={true}
          >
            <div className={classes.courseDetailsBody}>
              {_.map(filteredGrades, ({ id, name, studentCount }, indx) => {
                return (
                  <div
                    key={`grade_name_${indx}`}
                    className={classes.assignedCalGradesContainer}
                  >
                    <div className={classes.assignedCalendarLabel}>
                      <Avatar
                        shape={"square"}
                        size={"small"}
                        name={name || ""}
                        id={id || ""}
                        dsVersion={"2.0"}
                      />
                      <div className={classes.gradeDetail}>
                        <div className={"text-body"}>{name || ""}</div>
                        <div
                          className={classNames(
                            "text-body-s",
                            classes.subTitle
                          )}
                        >
                          {t("common:student_count", { count: studentCount })}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </AnimateHeight>
        </div>
        {isStaff ? (
          <div className={classes.right} data-test-id={`${testId}-assigned-to`}>
            <div className={arrowIconStyle}>
              {_.size(gradeNamesList) > 1 ? <ChevronDownOutlined /> : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
});

CalendarWiseAssignedGrades.displayName = "CalendarWiseAssignedGrades";

const SectionTitleCountLabel = ({ userCount, title }) => {
  return (
    <div className={classes.calendarLabel}>
      <div className={classes.userCount}>{userCount}</div>
      <div className={classes.title}>{title}</div>
    </div>
  );
};

const PendingCompletedStatusLabel = ({
  t,
  pendingProjectsObject,
  completedProjectsObject,
  pendingProjectsCount,
  completedProjectsCount,
  isNoStudentAssigned,
  turnedInCount,
  isStudentSubmissionEnabled,
}) => {
  return isNoStudentAssigned ? (
    <div className={classes.studentEmptyStateText}>
      {t("calendar:no_students_are_assigned_to_this_deadline")}
    </div>
  ) : (
    <div className={classes.projectStatus}>
      <div className={classes.pendingText}>
        <div className={classes.countText}>{pendingProjectsCount}</div>
        <div className={classes.statusText}>
          {_.get(pendingProjectsObject, "status", "")}
        </div>
      </div>
      {isStudentSubmissionEnabled ? (
        <div className={classes.turnedInText}>
          <div className={classes.countText}>{turnedInCount}</div>
          <div className={classes.statusText}>{t("project:turned_in")}</div>
        </div>
      ) : null}
      {completedProjectsCount ? (
        <div className={classes.completedText}>
          <div className={classes.countText}>{completedProjectsCount}</div>
          <div className={classes.statusText}>
            {_.get(completedProjectsObject, "status", "")}
          </div>
        </div>
      ) : null}
    </div>
  );
};

const SubmissionStatusWiseAssignedUsers = React.memo(props => {
  const {
    t,
    submissionStatusStudentList,
    defaultStudentNameOrderPreference,
    testId,
    turnedInCount,
    isStudentSubmissionEnabled,
    title,
  } = props;
  const [isCourseStudentsVisible, setIsCourseStudentsVisible] = useState(false);

  useEffect(() => {
    setIsCourseStudentsVisible(false);
  }, [submissionStatusStudentList]);

  const assignedStudents = _.chain(submissionStatusStudentList)
    .filter(
      ({ students, status }) =>
        !_.isEmpty(students) &&
        !_.isEqual(status, submissionStatusStudentList?.COMPLETED?.status)
    )
    .map("students")
    .flatten()
    .uniqBy("id")
    .value();

  const studentCount = _.size(assignedStudents);
  if (isNewParticipantSelectorEnabled()) {
    return (
      <div className={classes.courseDetails}>
        <ParticipantsSummary
          label={t("common:student_plural")}
          totalCount={studentCount}
          summaryText={`${studentCount} ${t("common:pending")}`}
          eventTitle={title}
          associatedEntities={assignedStudents}
          sharedWith={["STUDENT"]}
          staffCount={0}
          studentCount={studentCount}
          familyCount={0}
        />
      </div>
    );
  }

  const arrowIconStyle = classNames(
    { [classes.arrowIcon]: true },
    { [classes.arrowIconReversed]: isCourseStudentsVisible }
  );

  const pendingProjectsObject = _.get(submissionStatusStudentList, PENDING, {});
  const completedProjectsObject = _.get(
    submissionStatusStudentList,
    COMPLETED,
    {}
  );
  const pendingProjectsCount = _.size(
    _.get(pendingProjectsObject, "students", [])
  );
  const completedProjectsCount = _.size(
    _.get(completedProjectsObject, "students", [])
  );

  const isNoStudentAssigned = !pendingProjectsCount && !completedProjectsCount;

  const showStudentHandler = () => {
    setIsCourseStudentsVisible(state => !state && !isNoStudentAssigned);
  };

  const handleKeyDown = event => {
    onEnterOrSpaceKeyDown(event, showStudentHandler);
  };

  return (
    <div className={classes.courseDetails}>
      <div
        className={classes.courseDetailsHeader}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        onClick={showStudentHandler}
      >
        <div className={classes.left}>
          <div className={classes.assignedToLabel}>
            {t("project:student_progress")}
          </div>
          {!isCourseStudentsVisible ? (
            <div className={classNames("text-body", classes.courseSummary)}>
              <PendingCompletedStatusLabel
                t={t}
                pendingProjectsObject={pendingProjectsObject}
                completedProjectsObject={completedProjectsObject}
                pendingProjectsCount={pendingProjectsCount}
                completedProjectsCount={completedProjectsCount}
                isNoStudentAssigned={isNoStudentAssigned}
                turnedInCount={turnedInCount}
                isStudentSubmissionEnabled={isStudentSubmissionEnabled}
              />
            </div>
          ) : (
            <AnimateHeight
              height={"auto"}
              duration={300}
              onAnimationStart={null}
              onAnimationEnd={null}
              animateOpacity={true}
            >
              <div className={classes.courseDetailsBody}>
                {_.map(submissionStatusStudentList, (list, index) => {
                  const { status, students } = list;
                  if (
                    _.isEmpty(students) &&
                    _.isEqual(
                      status,
                      submissionStatusStudentList?.COMPLETED?.status
                    )
                  ) {
                    return null;
                  }
                  return (
                    <div
                      key={index}
                      className={classes.assignedCalUsersContainer}
                    >
                      <div className={classes.assignedCalendarLabel}>
                        <SectionTitleCountLabel
                          title={status}
                          userCount={students?.length}
                        />
                      </div>
                      <div className={classes.studentListContainer}>
                        {_.map(students, student => {
                          const name = getFormattedUserName({
                            user: student,
                            type: "student",
                            defaultStudentNameOrderPreference,
                          });
                          const studentId = _.get(student, "id");
                          const studentProfileImage = _.get(
                            student,
                            "profileImage"
                          );
                          const avatarColor = getRandomColorForAvatar({
                            id: studentId,
                          });
                          const alertTypes = _.get(student, "alertTypes", []);
                          const {
                            label: statusLabel,
                            textColor: statusLabelColor,
                          } = getSubmissionStatusLabelDetails({
                            status: student?.submissionStatus,
                          });

                          const nameClasses = classNames(
                            "text-body",
                            classes.name,
                            classes.studentNameContainer
                          );

                          return (
                            <div
                              key={studentId}
                              className={classes.studentProfile}
                            >
                              <Avatar
                                shape={"square"}
                                size={"small"}
                                name={name}
                                id={studentId}
                                src={studentProfileImage}
                                dsVersion={"2.0"}
                              />
                              <div className={classes.studentDetailsContainer}>
                                <div className={nameClasses}>
                                  <span>{name}</span>
                                  <StudentAlerts
                                    studentId={studentId}
                                    alertTypes={alertTypes}
                                  />
                                </div>
                                {isStudentSubmissionEnabled ? (
                                  <div
                                    style={{ color: statusLabelColor }}
                                    className="text-body-s"
                                  >
                                    {t(statusLabel)}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          );
                        })}
                        {_.isEmpty(students) ? (
                          <div className={classes.studentEmptyStateText}>
                            {_.isEqual(
                              status,
                              submissionStatusStudentList?.COMPLETED?.status
                            )
                              ? t(
                                  "calendar:no_students_have_completed_this_task"
                                )
                              : t(
                                  "calendar:all_students_have_completed_this_task"
                                )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            </AnimateHeight>
          )}
        </div>
        <div className={classes.right} data-test-id={`${testId}-assigned-to`}>
          <div className={arrowIconStyle}>
            {!isNoStudentAssigned ? <ChevronDownOutlined /> : null}
          </div>
        </div>
      </div>
    </div>
  );
});

SubmissionStatusWiseAssignedUsers.displayName =
  "SubmissionStatusWiseAssignedUsers";

const RenderDatePickers = ({
  updateStartDate,
  updateEndDate,
  startDateLocal,
  endDateLocal,
  itemType,
  showTimeSelector,
  isCurrentAcademicYear,
  calendarView,
  isCalendarDeadlineView,
  disabled,
  academicYearStartDate,
  academicYearEndDate,
  nextAcademicYearEndDate,
  currentCurriculumProgramType,
  testId,
  viewSource,
  isFullDayEvent,
  setLocalDateState,
}) => {
  const isTimedEvent =
    itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT && !isFullDayEvent;

  const minStartDate = getDateMomentObject(academicYearStartDate);
  const maxStartDate = getDateMomentObject(academicYearEndDate);

  // Convert UTC datetime to local datetime first
  const startDateInLocalTimezone = moment(startDateLocal).local().format();
  const endDateInLocalTimezone = moment(endDateLocal).local().format();

  const startTimeForEvent = formatDate({
    date: startDateInLocalTimezone,
    format: DATE_TIME_CONSTANTS.HH_mm,
  });
  const endTimeForEvent = formatDate({
    date: endDateInLocalTimezone,
    format: DATE_TIME_CONSTANTS.HH_mm,
  });

  const scheduleEndTime = formatDateAsUtc({
    date: startDateInLocalTimezone,
    format: DATE_TIME_CONSTANTS.HH_mm,
  });

  const startDateLocalMomentObject = getDateMomentObjectCustom(
    moment(startDateInLocalTimezone).local(),
    DATE_TIME_CONSTANTS.YYYY_MM_DD
  );

  const endDateLocalMomentObject = getDateMomentObjectCustom(
    endDateLocal,
    DATE_TIME_CONSTANTS.YYYY_MM_DD
  );

  const updateTimeOfDate = ({
    newTime = scheduleEndTime,
    newDate = startDateLocalMomentObject,
  }) => {
    const deadlineDateMomentObject = getDateMomentObjectCustom(
      newDate,
      DATE_TIME_CONSTANTS.YYYY_MM_DD
    );
    const scheduleEndTimeMomentObject = getDateMomentObjectCustom(
      newTime,
      DATE_TIME_CONSTANTS.HH_mm
    );

    deadlineDateMomentObject.hour(scheduleEndTimeMomentObject.hour());
    deadlineDateMomentObject.minute(scheduleEndTimeMomentObject.minute());

    const deadlineDateTimeUTC = deadlineDateMomentObject.utc(true);

    updateStartDate(deadlineDateTimeUTC);
  };

  const handleUpdateDay = newDate => {
    updateTimeOfDate({
      newDate,
    });
  };

  const handleUpdateTime = newTime => {
    updateTimeOfDate({
      newTime,
    });
  };

  const updateEventTime = ({ newTime, isStartTimeUpdate }) => {
    const targetDate = startDateInLocalTimezone;
    const dateMomentObject = getDateMomentObjectCustom(
      targetDate,
      DATE_TIME_CONSTANTS.YYYY_MM_DD
    );
    const scheduleTimeMomentObject = getDateMomentObjectCustom(
      newTime,
      DATE_TIME_CONSTANTS.HH_mm
    );

    dateMomentObject.hour(scheduleTimeMomentObject.hour());
    dateMomentObject.minute(scheduleTimeMomentObject.minute());

    const newDateTime = getISOString(dateMomentObject);
    const newMoment = getDateMomentObjectCustom(newDateTime);
    const compareMoment = getDateMomentObjectCustom(
      isStartTimeUpdate ? endDateLocal : startDateInLocalTimezone
    );

    const newState = {
      startDateLocal: isStartTimeUpdate
        ? newDateTime
        : startDateInLocalTimezone,
      endDateLocal: isStartTimeUpdate ? endDateLocal : newDateTime,
    };

    // Handle time conflicts
    if (isStartTimeUpdate) {
      // Start time conflicts with end time - adjust end time

      const currentDuration = getDateMomentObject(endDateLocal).diff(
        getDateMomentObject(startDateLocal)
      );
      const newEndDate = newMoment.clone().add(currentDuration, "milliseconds");

      if (newEndDate.format("YYYY-MM-DD") === newMoment.format("YYYY-MM-DD")) {
        newState.endDateLocal = getISOString(newEndDate);
      } else {
        newState.endDateLocal = getISOString(newMoment.clone().endOf("day"));
      }
    } else if (!isStartTimeUpdate && newMoment.isSameOrBefore(compareMoment)) {
      // End time conflicts with start time - adjust start time
      const adjustedStartMoment = newMoment.clone().subtract(30, "minutes");
      newState.startDateLocal = getISOString(adjustedStartMoment);
    }

    setLocalDateState(newState);
  };

  const updateStartTimeForEvent = newTime => {
    updateEventTime({ newTime, isStartTimeUpdate: true });
  };

  const updateEndTimeForEvent = newTime => {
    updateEventTime({ newTime, isStartTimeUpdate: false });
  };

  const nextAcademicYearEndDateMomentObject = getDateMomentObjectCustom(
    nextAcademicYearEndDate,
    DATE_TIME_CONSTANTS.YYYY_MM_DD
  );

  const isDpCurriculum = _.isEqual(
    currentCurriculumProgramType,
    CURRICULUM_TYPE_DP
  );

  const maxDateForDatePicker = isDpCurriculum
    ? nextAcademicYearEndDateMomentObject
    : maxStartDate;

  const handleUpdateDayForTimedEvent = newDate => {
    // Q. Why do we need to add time to date while updating day for timed event?
    // A. Because the date picker returns the stale time when user tries to update the day for a timed event,
    // as the time is not part of the date picker value,
    // we need to add the time to the new date to avoid changing the time of the event when user updates the day.
    const newStartDate = getDateMomentObjectCustom(
      `${formatDate({
        date: newDate,
        format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
      })}:${formatDate({
        date: startDateLocal,
        format: DATE_TIME_CONSTANTS.HH_mm,
      })}`,
      DATE_TIME_CONSTANTS.YYYY_MM_DD__HH_mm
    );

    updateStartDate(newStartDate, true);
  };

  return (
    <div className={classes.dateContainer}>
      <div className={classNames({ [classes.marginRight]: showTimeSelector })}>
        <DatePicker
          onChange={
            isTimedEvent ? handleUpdateDayForTimedEvent : updateStartDate
          }
          picker="date"
          format={DATE_TIME_CONSTANTS.ddd_MMM_DD}
          value={startDateLocalMomentObject}
          variant="inline"
          inputReadOnly={true}
          minDate={minStartDate}
          maxDate={maxDateForDatePicker}
          disabled={disabled}
          testId={testId}
          dsVersion={"1.0"}
        />
      </div>

      {showTimeSelector ? (
        <div className={classes.timepicker}>
          <TimeSelectorByPerm
            value={scheduleEndTime}
            updateInputField={handleUpdateTime}
            startTime={END_PICKER_START_TIME}
            endTime={END_PICKER_END_TIME}
            scheduleDate={startDateLocal}
            isCurrentAcademicYear={isCurrentAcademicYear}
            calendarView={calendarView}
            isCalendarDeadlineView={isCalendarDeadlineView}
            testId={`${testId}-time`}
            viewSource={viewSource}
            disabled={disabled}
          />
        </div>
      ) : null}

      {itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
      isFullDayEvent ? (
        <>
          <div className={classNames("text-body", classes.timeBetweenText)}>
            {"-"}
          </div>
          <DatePicker
            onChange={updateEndDate}
            picker="date"
            format={DATE_TIME_CONSTANTS.ddd_MMM_DD}
            value={endDateLocalMomentObject}
            variant="inline"
            inputReadOnly={true}
            minDate={startDateLocalMomentObject}
            testId={testId}
            maxDate={maxDateForDatePicker}
            dsVersion={"1.0"}
            disabled={disabled}
          />
        </>
      ) : null}
      {isTimedEvent ? (
        <div className={classes.timePair}>
          <div className={classes.timepicker}>
            <TimeSelectorByPerm
              value={startTimeForEvent}
              updateInputField={updateStartTimeForEvent}
              startTime={END_PICKER_START_TIME}
              endTime={END_PICKER_END_TIME}
              scheduleDate={startDateLocal}
              isCurrentAcademicYear={isCurrentAcademicYear}
              calendarView={calendarView}
              isCalendarDeadlineView={isCalendarDeadlineView}
              testId={`${testId}-startTime`}
              viewSource={viewSource}
              disabled={disabled}
            />
          </div>
          <div className={classNames("text-body", classes.timeBetweenText)}>
            {"-"}
          </div>
          <div className={classes.timepicker}>
            <TimeSelectorByPerm
              value={endTimeForEvent}
              updateInputField={updateEndTimeForEvent}
              startTime={END_PICKER_START_TIME}
              endTime={END_PICKER_END_TIME}
              scheduleDate={startDateLocal}
              isCurrentAcademicYear={isCurrentAcademicYear}
              calendarView={calendarView}
              isCalendarDeadlineView={isCalendarDeadlineView}
              testId={`${testId}-endTime`}
              viewSource={viewSource}
              disabled={disabled}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

const TimeSelectorByPerm = props => {
  const {
    value,
    updateInputField,
    startTime,
    endTime,
    disableConfirmButton,
    scheduleDate,
    isCurrentAcademicYear,
    calendarView,
    isCalendarDeadlineView,
    testId,
    viewSource,
    disabled,
  } = props;

  const [timeHover, setTimeHover] = useState(false);

  const timeComponentStyle = {
    ...styles.timeSelectorTimeComponentStyle,
    ...(timeHover
      ? { backgroundColor: "var(--surface-secondary-active)" }
      : {}),
  };

  const onMouseEnterHandler = () => setTimeHover(true);
  const onMouseLeaveHandler = () => setTimeHover(false);

  const calculatedZIndexOfDropdown = 1002;

  return (
    <div onMouseEnter={onMouseEnterHandler} onMouseLeave={onMouseLeaveHandler}>
      <TimeSelectorV2
        showInputIcon={false}
        value={value}
        SelectedTimeformat={DATE_TIME_CONSTANTS.HH_mm}
        isValueMomentObj={false}
        updateInputField={updateInputField}
        isDisabled={
          _.isEmpty(scheduleDate) || !isCurrentAcademicYear || disabled
        }
        startTime={startTime}
        endTime={endTime}
        dropdownItemStyle={styles.timeSelectorDropdownItemStyle}
        dropdownContainerStyle={styles.timeSelectorDropdownContainerStyle}
        containerStyle={styles.timeSelectorContainerStyle}
        inputStyle={styles.timeSelectorInputStyle}
        timeComponentStyle={timeComponentStyle}
        showBorder={false}
        disableConfirmButton={disableConfirmButton}
        alwaysShowTooltip={true}
        showInputBorderOnFocus={true}
        positionDropdownDivWithPopover={true}
        dropdownParentContainerStyle={
          styles.timeSelectorDropdownParentContainerStyle
        }
        dropdownParentStyle={styles.timeSelectorDropdownParentContainerStyle}
        showPlaceholderWhenDisabled={false}
        popoverZIndex={calculatedZIndexOfDropdown}
        minuteStep={5}
        testId={`${testId}-UIComponents-timeSelectorV2`}
      ></TimeSelectorV2>
    </div>
  );
};

const useConfirmationModal = ({ updateEventModalV2, repeatEventSettings }) => {
  const setRepeatScope = setValue("repeatScope", updateEventModalV2);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const onCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  const repeatEventModalActionRef = useRef({});

  const onSaveRecurrenceHandler = value => {
    setIsConfirmationModalOpen(true);
    repeatEventModalActionRef.current?.close?.();
    setRepeatScope(value);
  };

  const clickHandler = () => {
    if (
      isRecurringSchoolCalendarEventActionsEnabled() &&
      !_.isEmpty(repeatEventSettings)
    ) {
      repeatEventModalActionRef.current?.open?.();
      return;
    }
    setIsConfirmationModalOpen(true);
  };

  return {
    isConfirmationModalOpen,
    openConfirmationModal,
    onCloseConfirmationModal,
    repeatEventModalActionRef,
    onSaveRecurrenceHandler,
    clickHandler,
  };
};

const EventDetails = props => {
  // component props
  const {
    t,
    gradeList,
    eventData,
    onCloseClick,
    refetchRotationDays,
    deleteSchoolCalendarEvent,
    dateText,
    userType,
    userId,
    goToRelativeRoute,
    viewSource,
    deleteDeadlineItem,
    currentCurriculumProgramType,
    selectedViewOnlyTags,
    courseId,
    defaultStudentNameOrderPreference,
    setToastMsg,
    editSchoolCalendarEvent,
    updateDeadlineItem,
    getIsCurrentAcademicYear,
    calendarView,
    isCalendarDeadlineView,
    projectGroups,
    disabled = false,
    showCalendarAssignmentByDueDate,
    hideViewMoreBtn,
    updateNavigationObject,
    currentCurriculumProgramId,
    userCoursesIds,
    isStaff,
    isParent,
    academicYearStartDate,
    academicYearEndDate,
    nextAcademicYearEndDate,
    testId,
    isUpcomingAcademicYear,
    eventsRef,
    onExpandItemClickCallback,
    projectGroupCategoryIdByType,
    deleteDeadlineV2,
    updateDeadlineV2,
    isStudentProfileCalendarView,
    isEventDetailsLoading,
    organizationId,
    academicYearId,
    isStaffSchoolCalendarAdmin,
    courseList,
    isAssociatedEntitiesDetailsLoading,
    associatedEntities: associatedEntitiesFromProps,
    isInMobile = false,
    updateEventModalV2,
    repeatScope,
    isNewEventCreationFlowFFEnabled,
    participantListType = ENTITY_TYPE_MAPPING.CUSTOM,
    organizationCurriculumPrograms,
  } = props;

  /*
  EventDetails component can be used independently outside MyCalendar component.
  Hence, we need to ensure that the refetchEvents & refetchAssignedData function is available either
  from props or we create a default one here to refetch the calendar events query 
  when the master calendar in in the background.
  */
  const client = useApolloClient();
  const refetchEvents =
    props?.refetchEvents ||
    getRefetchFunctionForQuery({ client, query: getCalendarEventsDataQuery });
  const refetchAssignedData =
    props?.refetchAssignedData ||
    getRefetchFunctionForQuery({
      client,
      query: getCalendarEventsParticipantDataQuery,
    });

  // other props
  let { itemType } = eventData;
  itemType = _.get(eventData, "item.eventType", itemType);
  const data = eventData;

  const item = _.get(data, "item", {});
  const {
    title,
    location,
    description,
    gradeIds,
    startDate,
    endDate,
    completedProjectsCount,
    pendingProjectsCount,
    eventTypeLabel,
    yearGroup = {},
    createdBy = {},
    projectGroupId,
    projectGroupType,
    tag,
    id,
    projectGroupLabel,
    projectGroupCourseIds,
    subject,
    completedStudents,
    pendingStudents,
    isDeadlineCompleted,
    isDeadlineAllDay,
    isProjectNewDeadline,
    assignedProjectsCount,
    isStudentSubmissionEnabled,
    turnedInCount,
    totalProjectsCount,
    rawStartDate,
    rawEndDate,
    isFullDayEvent,
    attachments,
    associatedEntities,
    sharedWith,
    eventReminders,
    users,
    recurringSetting,
    repeatEventSettings,
    metadata = {},
    categoryId,
  } = getTransformedEventData({
    itemType,
    data: item,
    userType,
    defaultStudentNameOrderPreference,
    eventItemId: _.get(data, "id"),
    eventData,
    associatedEntities: associatedEntitiesFromProps,
  });
  const projectGroupCourses = _.get(data, "projectGroup.courses.edges", []);
  const currCourseId = useMemo(
    () =>
      _.first(
        _.intersection(
          _.map(projectGroupCourses, course => _.get(course, "node.id")),
          userCoursesIds
        )
      ),
    [projectGroupCourses, userCoursesIds]
  );

  const projectCourseId = useMemo(
    () => _.head(_.intersection(projectGroupCourseIds, userCoursesIds)),
    [projectGroupCourseIds, userCoursesIds]
  );

  // state
  const [showEventCreationModal, setShowEventCreationModal] = useState(
    initialEventCreationModalObj
  );
  const isProjectDeadlineModal =
    itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT;
  const [showDeleteDialogueBox, setShowDeleteDialogueBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [
    showNewDeadlineModalDetails,
    setShowNewDeadlineModalDetails,
  ] = useState({});

  const [localDateState, _setLocalDateState] = useState({
    startDateLocal: startDate,
    endDateLocal: endDate,
  });

  const [localDateStateWithTime, setLocalDateStateWithTime] = useState({
    startDateLocalWithTime: startDate,
    endDateLocalWithTime: endDate,
  });

  const [showAllDescription, setShowAllDescription] = useState(false);

  const containerRef = useRef();

  let { startDateLocal, endDateLocal } = localDateState;
  const {
    startDateLocalWithTime,
    endDateLocalWithTime,
  } = localDateStateWithTime;

  const isTimedEvent =
    itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT && !isFullDayEvent;

  startDateLocal = isTimedEvent ? startDateLocalWithTime : startDateLocal;
  endDateLocal = isTimedEvent ? endDateLocalWithTime : endDateLocal;
  const setLocalDateStateWithTimeWrapper = useCallback(newState => {
    if (typeof newState === "function") {
      setLocalDateStateWithTime(prevState => {
        const updatedState = newState(prevState);
        return {
          startDateLocalWithTime: updatedState?.startDateLocal,
          endDateLocalWithTime: updatedState?.endDateLocal,
        };
      });
    } else {
      const { startDateLocal, endDateLocal } = newState || {};
      setLocalDateStateWithTime({
        startDateLocalWithTime: startDateLocal,
        endDateLocalWithTime: endDateLocal,
      });
    }
  }, []);
  const setLocalDateState = isTimedEvent
    ? setLocalDateStateWithTimeWrapper
    : _setLocalDateState;

  useEffect(() => {
    setLocalDateState({
      startDateLocal: startDate,
      endDateLocal: endDate,
    });
  }, [startDate, endDate, setLocalDateState]);

  useEffect(() => {
    containerRef?.current?.focus();
  }, []);

  const {
    isLoading: isRnpFetchLoading,
    isVisible: isCalendarEventInUserScope,
  } = useIsCalendarInUserScope({
    isStaff,
    userId,
    eventData,
    organizationId,
    academicYearId,
    currentCurriculumProgramId,
    isStaffSchoolCalendarAdmin,
    courseList,
    organizationCurriculumPrograms,
    setIsLoading,
  });
  const isHolidayOrWholeSchoolEvent = getIsHolidayOrWholeSchoolEvent(
    _.get(item, "tag")
  );

  const isQuickReschedule = () => {
    const isLocalStartDateChanged = !_.isEqual(startDate, startDateLocal);
    const isLocalEndDateChanged = !_.isEqual(endDate, endDateLocal);

    const isLocalEndDateChangedWithTime = !_.isEqual(
      endDateLocalWithTime,
      endDate
    );
    const isLocalStartDateChangedWithTime = !_.isEqual(
      startDateLocalWithTime,
      startDate
    );
    return isTimedEvent
      ? isLocalEndDateChangedWithTime || isLocalStartDateChangedWithTime
      : isLocalStartDateChanged || isLocalEndDateChanged;
  };

  const showTimeSelector = _.isEqual(isDeadlineAllDay, false);

  const isCurrentAcademicYear = getIsCurrentAcademicYear();
  const customStatusComponent = () => {
    return (
      <div className={classNames(classes.customDeadlineStatus, "text-body-s")}>
        <span>
          {t("common:label_count", {
            label: t("common:assigned"),
            count: assignedProjectsCount,
          })}{" "}
        </span>
        <span className={classes.dot}></span>
        {isStudentSubmissionEnabled ? (
          <span>
            {t("common:label_count", {
              label: t("project:turned_in"),
              count: completedProjectsCount,
            })}
          </span>
        ) : null}
        <span>
          {t("common:label_count", {
            label: t("common:completed"),
            count: completedProjectsCount,
          })}
        </span>
      </div>
    );
  };

  const submissionStatusStudentList = {
    PENDING: {
      status: t("common:pending"),
      students: pendingStudents,
    },
    COMPLETED: {
      status: t("common:completed"),
      students: completedStudents,
    },
  };

  const isNewCalendarEnabled = isMasterCalendarV1Enabled({
    currentCurriculumProgramType,
  });

  const { backgroundColor: tagColor = "" } =
    getEventMetadata({
      item,
      itemType,
      userType,
      isNewCalendarEnabled,
      currentCurriculumProgramId,
    }) || {};

  const yearGroupName = _.get(yearGroup, "name");
  const name = _.get(createdBy, "name");
  const profileImage = _.get(createdBy, "profileImage");
  const authorId = _.get(createdBy, "id", null);
  const filteredGrades = getGradesMemoize({ gradeIds, gradeList });
  const gradeNames = getGradeNamesMemoize({ gradeIds, gradeList });
  const gradeNamesList = useMemo(() => _.split(gradeNames, ", "), [gradeNames]);
  const selectedTimeSlot = { startDate, endDate };
  const { isVisible, eventType, action } = showEventCreationModal;
  const isUserStaff = isUserTypeStaff({ userType });
  const isViewOnlyTag = isViewOnlyTagMemoize({
    selectedViewOnlyTags,
    tag,
    projectGroupType,
    itemType,
  });

  const isMySchoolCalendarEvent =
    MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT === itemType;

  const isRecurringSchoolCalendarEventActionsFFEnabled = isRecurringSchoolCalendarEventActionsEnabled();

  const showNewEventParticipantList =
    isMySchoolCalendarEvent && isNewEventCreationFlowFFEnabled && isStaff;

  const canUserPerformActions = () => {
    //If viewing from student profile or event is not full day event then do not allow to perform any actions
    if (
      isStudentProfileCalendarView ||
      (!isFullDayEvent &&
        itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT)
    )
      return false;

    /*
    If it is upcoming academic year do not allow to edit/duplicate/delete through quick view modal for any user
    Only allow modification for events.

    This is because we don't show deadline cards for future academic year
    and then users doing these actions can have more edgecases for future year
    for example using duplicate I can create deadlines in future year
    */
    if (
      isUpcomingAcademicYear &&
      !_.isEqual(itemType, MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT)
    ) {
      return false;
    }

    let canPerformActions = isMasterCalendarV2Enabled() && isUserStaff;
    if (
      !isAdminForAllCalendarModules({
        currentCurriculumProgramType,
        projectGroupCategoryIdByType,
        currentCurriculumProgramId,
      })
    ) {
      if (itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) {
        canPerformActions = isStaffAdminForSchoolCalendarByContext({
          contexts: [
            {
              entityId: currentCurriculumProgramId,
              entityType: "CURRICULUM_PROGRAM",
            },
          ],
        });
      } else if (
        canEditIaOrEaDeadlineMemoize({
          projectGroups,
          projectGroupId,
          projectGroupType,
          isUserStaff,
        })
      ) {
        canPerformActions = true;
      } else {
        canPerformActions = isStaffAdminForProject({
          projectGroupType,
          projectGroupCategoryIdByType,
          curriculumProgramId: currentCurriculumProgramId,
        });
      }
    }
    if (
      itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
      !_.isEmpty(courseId)
    ) {
      canPerformActions = false;
    }
    if (isViewOnlyTag) {
      canPerformActions = false;
    }
    if (
      itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
      repeatEventSettings !== null
    ) {
      canPerformActions = isRecurringSchoolCalendarEventActionsFFEnabled
        ? true
        : false;
    }
    return canPerformActions;
  };

  // 2DTODO: Need cleanup, duplicated for now to handle new events quick view modal
  const canUserPerformActionsV2 = () => {
    //If viewing from student profile or event is not full day event then do not allow to perform any actions
    if (isStudentProfileCalendarView) return false;

    /*
    If it is upcoming academic year do not allow to edit/duplicate/delete through quick view modal for any user
    Only allow modification for events.

    This is because we don't show deadline cards for future academic year
    and then users doing these actions can have more edgecases for future year
    for example using duplicate I can create deadlines in future year
    */
    if (
      isUpcomingAcademicYear &&
      !_.isEqual(itemType, MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT)
    ) {
      return false;
    }

    let canPerformActions = isMasterCalendarV2Enabled() && isUserStaff;
    if (
      !isAdminForAllCalendarModules({
        currentCurriculumProgramType,
        projectGroupCategoryIdByType,
        currentCurriculumProgramId,
      })
    ) {
      if (itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) {
        canPerformActions = isStaffAdminForSchoolCalendarByContext({
          contexts: [
            {
              entityId: currentCurriculumProgramId,
              entityType: "CURRICULUM_PROGRAM",
            },
          ],
        });
      } else if (
        canEditIaOrEaDeadlineMemoize({
          projectGroups,
          projectGroupId,
          projectGroupType,
          isUserStaff,
        })
      ) {
        canPerformActions = true;
      } else {
        canPerformActions = isStaffAdminForProject({
          projectGroupType,
          projectGroupCategoryIdByType,
          curriculumProgramId: currentCurriculumProgramId,
        });
      }
    }
    if (itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) {
      const userEventCreationAccessLevel = getUserEventCreationAccessLevel({
        currentCurriculumProgramId,
        alsoCheckClassLevelPermission: false,
      });

      const userCanCreateHolidaysAndWholeSchoolEvents = _.includes(
        ["ACCOUNT_LEVEL", "PROGRAM_LEVEL"],
        userEventCreationAccessLevel
      );
      canPerformActions =
        _.isEqual(userId, createdBy?.id) ||
        userCanCreateHolidaysAndWholeSchoolEvents;
    }
    if (isViewOnlyTag) {
      canPerformActions = false;
    }
    if (
      itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
      repeatEventSettings !== null
    ) {
      canPerformActions =
        isRecurringSchoolCalendarEventActionsFFEnabled && isUserStaff
          ? true
          : false;
    }
    return canPerformActions;
  };

  const canPerformActions = isNewEventCreationFlowFFEnabled
    ? canUserPerformActionsV2()
    : canUserPerformActions();

  const eventDetails = getEventDetails({
    itemType,
    id,
    title,
    description,
    location,
    gradeIds,
    gradeList,
    tag,
    projectGroupId,
    projectGroupType,
    projectGroupLabel,
    yearGroup,
    subject,
    t,
    isDeadlineAllDay,
    isFullDayEvent,
    sharedWith,
    associatedEntities,
    attachments,
    eventReminders,
    users,
    repeatEventSettings,
    metadata,
    endDate,
  });

  const {
    isConfirmationModalOpen,
    openConfirmationModal,
    onCloseConfirmationModal,
    repeatEventModalActionRef,
    onSaveRecurrenceHandler,
    clickHandler,
  } = useConfirmationModal({
    updateEventModalV2,
    repeatEventSettings: eventDetails?.repeatEventSettings,
  });

  const escapePress = domEvent => {
    const code = domEvent.keyCode ? domEvent.keyCode : domEvent.which;
    if (code == 27) {
      domEvent.stopPropagation();
      onCloseModal();
      toggleDialogueBoxDisplay();

      if (eventsRef) {
        const eventId = _.get(eventData, "id");
        eventsRef.current[eventId]?.focus();
      }
    }
  };

  // this is required to preserve reference of escapePress
  // so that we can remove the event listener on component unmount or when edit button press
  // (which opens the edit event form and we don't want this escape key function to work when the edit form is open,
  //  as the edit form will have its own escape key handling)
  const escapeFuncRef = useRef(escapePress);

  const onEditEvent = () => {
    if (canPerformActions) {
      if (isProjectNewDeadline) {
        setShowNewDeadlineModalDetails({
          displayModal: true,
          action: EDIT,
        });
      } else {
        // remove this on click edit because this override the escape behaviour of edit event modal
        document.removeEventListener("keydown", escapeFuncRef.current, true);
        setShowEventCreationModal({
          isVisible: true,
          eventType: itemType,
          action: EDIT,
          isDeadlineAllDay,
        });
      }
    }
  };

  const onCopyEvent = () => {
    if (canPerformActions) {
      if (isProjectNewDeadline) {
        setShowNewDeadlineModalDetails({
          displayModal: true,
          action: DUPLICATE,
        });
      } else {
        setShowEventCreationModal({
          isVisible: true,
          eventType: itemType,
          action: DUPLICATE,
          isDeadlineAllDay,
        });
      }
    }
  };

  const toggleDialogueBoxDisplay = () => {
    setShowDeleteDialogueBox(!showDeleteDialogueBox);
  };

  const onDeleteConfirmClick = async () => {
    try {
      switch (itemType) {
        case MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT:
          await deleteSchoolCalendarEvent({ id, isFullDayEvent });
          break;
        default: {
          if (isProjectNewDeadline) {
            await deleteDeadlineV2({
              input: { id },
              refetchQueries: false,
            });
          } else {
            await deleteDeadlineItem({
              projectGroupId,
              deadlineItem: { id },
            });
          }
          setToastMsg({
            msg: "toastMsgs:event_deleted_successfully",
            type: "success",
          });
          break;
        }
      }
    } catch (err) {
      console.error(err);
      setToastMsg("toastMsgs:something_went_wrong");
    }

    onCloseEventDetailsModal();
    setShowDeleteDialogueBox(false);
  };

  const handleDeleteEvent = async () => {
    if (canPerformActions) {
      setShowDeleteDialogueBox(true);
    }
  };

  const onCloseEventDetailsModal = () => {
    onCloseClick && onCloseClick();
    setShowEventCreationModal(initialEventCreationModalObj);
    refetchEvents && refetchEvents();
    refetchAssignedData && refetchAssignedData();
    refetchRotationDays && refetchRotationDays();
  };

  const onCloseEventCreationModal = () => {
    setShowEventCreationModal(initialEventCreationModalObj);
  };

  const onCloseModal = () => {
    onCloseClick({ isCloseClicked: true });
  };

  const onViewTaskBtnClick = () => {
    let route;
    onCloseModal();
    if (onExpandItemClickCallback) onExpandItemClickCallback(); // close sidebar when view deadline is clicked
    const isCourseBasedProject = _.includes(
      [
        PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
        PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
      ],
      projectGroupType
    );

    if (
      currentCurriculumProgramType === CURRICULUM_TYPE_MYP ||
      (currentCurriculumProgramType === CURRICULUM_TYPE_DP &&
        !isCourseBasedProject)
    ) {
      const projectId = isProjectNewDeadline
        ? _.get(data, "item.mappedProject.id")
        : _.get(data, "item.project.id");

      updateNavigationObject({
        projectCommentBox: {
          showProjectCommentBox: true,
          commentParentEntityType: PROJECT_DEADLINE_REMINDER,
          itemId: _.get(data, "item.deadline.id", null),
        },
      });
      route = isStaff
        ? `/platform/${currentCurriculumProgramId}/project-group-types/${projectGroupType}/projects/${projectGroupId}/`
        : `/platform/${currentCurriculumProgramId}/project-group-types/${projectGroupType}/projects/${projectGroupId}/progress/${projectId}`;
    } else if (
      isCourseBasedProject &&
      currentCurriculumProgramType === CURRICULUM_TYPE_DP &&
      projectCourseId
    ) {
      const projectId = isProjectNewDeadline
        ? _.get(data, "item.mappedProject.id")
        : _.get(data, "item.project.id");

      updateNavigationObject({
        projectCommentBox: {
          showProjectCommentBox: true,
          commentParentEntityType: PROJECT_DEADLINE_REMINDER,
          itemId: _.get(data, "item.deadline.id", null),
        },
      });
      route = `/platform/${currentCurriculumProgramId}/courses/${projectCourseId}/projects/${projectGroupId}/progress/${projectId}`;
    } else {
      if (!currCourseId && isStaff) return null;
      route = isStaff
        ? `/platform/${currentCurriculumProgramId}/courses/${currCourseId}/projects/${projectGroupId}/`
        : `/platform/${currentCurriculumProgramId}/projects/${projectGroupId}/`;
    }

    if (isStaff && itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT) {
      if (isProjectNewDeadline && totalProjectsCount > 0) {
        route += `deadlines/${item?.id}`;
      } else {
        route += "deadlines/";
      }
    }

    goToRelativeRoute({
      route,
    });
  };

  const isYearGroupVisible = () => {
    return (
      itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT && yearGroupName
    );
  };

  const isViewTaskButtonVisible = () => {
    /*
    If it is upcoming academic year do not allow to view or update through quick view modal for any user

    This is because we don't show deadline cards for future academic year and then users were able
    to navigate to deadlines module using view button
    */
    if (isUpcomingAcademicYear) return false;

    if (isStaff) {
      if (isIEAssessment({ projectGroupSubType: projectGroupType })) {
        return (
          itemType !== MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
          currCourseId &&
          !hideViewMoreBtn
        );
      }
      return (
        itemType !== MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
        !hideViewMoreBtn &&
        _.includes(projectGroups, projectGroupId)
      );
    }
    return (
      itemType !== MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
      !hideViewMoreBtn
    );
  };

  const eventTypeTextClasses = classNames(
    "text-label-l",
    classes.eventTypeText
  );
  const detailsHeaderClasses = classNames({
    [classes.detailsHeader]:
      location || description || gradeNames || isYearGroupVisible(),
  });

  const isEventCreatedByTheCurrentUser = authorId === userId;

  const assigneeName = isEventCreatedByTheCurrentUser ? t("common:you") : name;
  const weekDays =
    _.size(repeatEventSettings?.weekDays) === 1
      ? [getDateMomentObject(startDateLocal)?.day()]
      : repeatEventSettings?.weekDays;

  const onConfirmBtnClick = async (data = {}) => {
    if (isStaff && isQuickReschedule()) {
      setIsLoading(true);
      if (itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT) {
        const repeatEventEndDate = getDateMomentObject(
          eventDetails?.repeatEventSettings?.endDate
        );
        const recurrenceSetting = isRepeatEvent
          ? {
              ...eventDetails?.repeatEventSettings,
              weekDays,
              endDate: repeatEventEndDate?.isValid()
                ? formatDate({
                    date: repeatEventEndDate,
                    format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
                  })
                : null,
            }
          : null;
        const { message, sendMessage } = data;

        const { associatedEntities = [], users = [] } = eventDetails || {};
        const isSuccess = await editSchoolCalendarEvent({
          id,
          start: getDateMomentObject(startDateLocal),
          end: getDateMomentObject(endDateLocal),
          isFullDayEvent,
          message,
          description,
          shouldNotifyParticipants: sendMessage,
          title,
          eventReminders: _.map(
            eventReminders,
            ({ __typename, ...rest }) => rest
          ),
          sharedWith,
          location,
          metadata: isRepeatEvent
            ? {
                skipNonOperationalDays: false,
                ..._.omit(metadata, "__typename"),
              }
            : null,
          actionFor: repeatScope || "ALL",
          categoryId,
          recurrenceSetting: isRepeatEvent
            ? _.omit(recurrenceSetting, ["id", "endType"])
            : null,
          entityIds: [
            ..._.map(associatedEntities, "id"),
            ..._.map(users, "id"),
          ],
          entityType: participantListType,
        });
        if (isSuccess) onCloseModal();
      } else {
        const currentDateTimeString = formatDate({
          date: startDateLocal,
          format: DATE_TIME_CONSTANTS.YYYY_MM_DD_HH_mm,
        });

        const localTimeMomentObject = getDateMomentObjectCustom(
          currentDateTimeString,
          DATE_TIME_CONSTANTS.YYYY_MM_DD_HH_mm
        );

        if (isProjectNewDeadline) {
          await updateDeadlineV2({
            input: {
              id,
              dueOn: moment(
                formatDate({
                  date: startDateLocal,
                  format: DATE_TIME_CONSTANTS.YYYY_MM_DD_HH_mm,
                })
              ),
            },
            sourceType: "calendar",
          });
          onCloseModal();
        } else {
          const isSuccess = await updateDeadlineItem({
            deadlineItem: {
              id,
              deadlineDate: localTimeMomentObject,
            },
          });
          if (isSuccess) {
            onCloseModal();
            setToastMsg({
              msg: "toastMsgs:event_update_success",
              type: "success",
            });
          } else {
            setToastMsg("toastMsgs:something_went_wrong");
          }
        }
      }
      refetchEvents();
      setIsLoading(false);
      return;
    }
  };

  const updateStartDateForTimedEvent = selectedDate => {
    setLocalDateStateWithTime({
      ...localDateStateWithTime,
      startDateLocalWithTime: selectedDate,
      endDateLocalWithTime: getDateMomentObjectCustom(
        `${formatDate({
          date: selectedDate,
          format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
        })}:${formatDate({
          date: endDateLocalWithTime,
          format: DATE_TIME_CONSTANTS.HH_mm,
        })}`,
        DATE_TIME_CONSTANTS.YYYY_MM_DD__HH_mm
      ),
    });
  };

  const updateStartDate = (selectedDate, isTimedEvent = false) => {
    if (isTimedEvent) {
      updateStartDateForTimedEvent(selectedDate);
      return;
    }
    const newDate = formatDate({
      date: selectedDate,
      format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
    });
    const isStartDateAfterEndDate = checkIsDateAfter({
      date1: getDateMomentObjectCustom(newDate, DATE_TIME_CONSTANTS.YYYY_MM_DD),
      date2: getDateMomentObjectCustom(
        endDateLocal,
        DATE_TIME_CONSTANTS.YYYY_MM_DD
      ),
    });

    let newDates = {
      startDateLocal: isDeadlineAllDay ? newDate : selectedDate,
    };
    if (isStartDateAfterEndDate) {
      newDates = { ...newDates, endDateLocal: newDate };
    }
    setLocalDateState({
      ...localDateState,
      ...newDates,
    });
  };

  const updateEndDate = selectedDate => {
    const newDate = formatDate({
      date: selectedDate,
      format: DATE_TIME_CONSTANTS.YYYY_MM_DD,
    });
    setLocalDateState({ ...localDateState, endDateLocal: newDate });
  };

  const componentLabel = `${_.get(
    subject,
    "name",
    ""
  )} | ${projectGroupLabel} `;

  const buttonLabel = isQuickReschedule()
    ? t("common:update")
    : t("common:view");

  useEffect(() => {
    document.addEventListener("keydown", escapeFuncRef.current, true);
    const escapeFunc = escapeFuncRef.current;
    return () => {
      document.removeEventListener("keydown", escapeFunc, true);
    };
  }, []);

  const onCloseNewDeadlineModal = () => {
    setShowNewDeadlineModalDetails({
      displayModal: false,
    });
  };
  const isEventDateChanged =
    !_.isEqual(
      getDateMomentObject(startDateLocal).format("YYYY-MM-DD"),
      getDateMomentObject(startDate).format("YYYY-MM-DD")
    ) ||
    !_.isEqual(
      getDateMomentObject(endDateLocal).format("YYYY-MM-DD"),
      getDateMomentObject(endDate).format("YYYY-MM-DD")
    );

  const getNewDeadlineModal = () => {
    const { action } = showNewDeadlineModalDetails;

    const {
      description,
      dueOn,
      closesOn,
      isStudentSubmissionEnabled,
      resources: { edges: resourcesArray = [] } = {},
      submission,
      projectGroup: { id: yearGroup },
    } = item;

    const {
      tag: { value: tagValue },
      eventName: title,
    } = eventDetails;

    const templateAttachments = _.filter(
      _.map(submission?.items, "template"),
      item => item
    );

    const deadlineDetails = {
      title,
      description,
      id,
      dueOn: moment(dueOn),
      closesOn: moment(closesOn),
      templateAttachments,
      isStudentSubmissionEnabled,
      organizationResources: _.map(resourcesArray, item => item.node),
      resources: _.map(resourcesArray, item => item?.node?.attachment),
      submission,
      yearGroup,
      tag: tagValue,
    };

    return (
      <DSProvider dsVersion="2.0">
        <CreateCalendarDeadlineModal
          onClose={onCloseNewDeadlineModal}
          overlayContainer={classes.assignmentModalOverlay}
          eventType={eventType}
          t={t}
          refetchEvents={refetchEvents}
          mode={action}
          eventDetailsProps={deadlineDetails}
          testId={`${testId}-createCalendarDeadlineModal`}
        />
      </DSProvider>
    );
  };

  const showNewActionDropdown =
    isNewEventCreationFlowFFEnabled &&
    canPerformActions &&
    !disabled &&
    !isProjectNewDeadline;

  const isSchoolCalendarEventActionsDisabled =
    itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
    !isCalendarEventInUserScope;

  const repeatLabelText = getSubText({
    t,
    repeatEventSettings: {
      ...repeatEventSettings,
      weekDays,
      repeatType: repeatEventSettings?.frequency,
      academicYearEndDate: academicYearEndDate,
      endDate: repeatEventSettings?.endDate
        ? getDateMomentObject(repeatEventSettings?.endDate).format()
        : null,
      endType: getEndType({
        repeatEventSettings,
        academicYearEndDate,
        count: repeatEventSettings?.count,
      }),
    },
    date: startDate,
  });

  const isRepeatEvent = !_.isEmpty(eventDetails?.repeatEventSettings);

  const { subtext: updatedLabelText } = getSummaryText({
    t,
    state: {
      ...repeatEventSettings,
      occurrences: repeatEventSettings?.count,
      repeatType: repeatEventSettings?.frequency,
      weekDays,
      endType: getEndType({
        repeatEventSettings: repeatEventSettings,
        academicYearEndDate: academicYearEndDate,
        count: repeatEventSettings?.count,
      }),
      academicYearEndDate: academicYearEndDate,
    },
    date: startDate,
  });

  return (
    <div
      className={classNames(
        classes.detailsContent,
        isInMobile && classes.detailsContentMobile
      )}
      ref={containerRef}
      tabIndex={-1}
      data-test-id={`${testId}-modal`}
    >
      <div className={classes.eventHeader}>
        <div className={classes.eventType}>
          <div
            className={classes.eventTypeBadge}
            style={{ backgroundColor: tagColor }}
          ></div>
          <div className={eventTypeTextClasses}>
            {itemType == MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT
              ? t(eventTypeLabel)
              : eventTypeLabel}
          </div>
        </div>
        <div className={classes.eventActionsContainer}>
          {showNewActionDropdown ? (
            <ActionsDropdown
              id={id}
              isFullDayEvent={isFullDayEvent}
              onCloseEventDetailsModal={onCloseEventDetailsModal}
              onCopyEvent={onCopyEvent}
              onEditEvent={onEditEvent}
              onDeleteEvent={handleDeleteEvent}
              isEventDetailsLoading={isEventDetailsLoading}
              isCalendarEventInUserScope={isCalendarEventInUserScope}
              isRepeatEvent={!_.isEmpty(eventDetails?.repeatEventSettings)}
              eventTitle={title}
              testId={testId}
            />
          ) : null}
          {canPerformActions && !disabled && !showNewActionDropdown ? (
            <>
              {isProjectNewDeadline ? null : (
                <IconButton
                  icon={<CopyOutlined variant={"subtle"} />}
                  style={styles.iconButtonCustomStyles}
                  onClick={onCopyEvent}
                  variant={"neutral"}
                  type={"plain"}
                  size={"medium"}
                  isCompact={true}
                  testId={`${testId}-header-copy`}
                  disabled={isEventDetailsLoading}
                  dsVersion={"2.0"}
                />
              )}
              <IconButton
                icon={<PencilOutlined variant={"subtle"} />}
                style={styles.iconButtonCustomStyles}
                onClick={onEditEvent}
                variant={"neutral"}
                type={"plain"}
                size={"medium"}
                isCompact={true}
                testId={`${testId}-header-edit`}
                disabled={isEventDetailsLoading}
                dsVersion={"2.0"}
              />
              {itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
              isNewEventCreationFlowFFEnabled ? (
                <DeleteEventButton
                  style={styles.iconButtonCustomStyles}
                  id={id}
                  isFullDayEvent={isFullDayEvent}
                  onCloseEventDetailsModal={onCloseEventDetailsModal}
                  isRepeatEvent={_.isEmpty(eventDetails?.repeatEventSettings)}
                />
              ) : (
                <IconButton
                  icon={<DeleteOutlined variant={"subtle"} />}
                  style={styles.iconButtonCustomStyles}
                  onClick={handleDeleteEvent}
                  variant={"neutral"}
                  type={"plain"}
                  size={"medium"}
                  isCompact={true}
                  testId={`${testId}-header-delete`}
                  dsVersion={"2.0"}
                />
              )}
            </>
          ) : null}
          {onCloseClick && (
            <IconButton
              icon={<CloseOutlined variant={"subtle"} />}
              style={styles.iconButtonCustomStyles}
              onClick={onCloseModal}
              variant={"neutral"}
              type={"plain"}
              size={"medium"}
              isCompact={true}
              testId={`${testId}-header-close`}
              dsVersion={"2.0"}
            />
          )}
        </div>
      </div>

      <div className={classes.eventBody}>
        <div className={detailsHeaderClasses}>
          <Tooltip tooltip={title}>
            <h5
              className={classNames(classes.eventTitle)}
              dir="auto"
              data-test-id={`${testId}-title`}
            >
              {title}
            </h5>
          </Tooltip>
          <div className={classes.dueOnDateLabel}>
            {getDateLabel({
              showCalendarAssignmentByDueDate,
              t,
              eventDateTime: startDateLocal,
              eventEndDateTime: endDateLocal,
              isSchoolCalendarEvent:
                itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT,
              isDeadlineEvent:
                itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
              isProjectNewDeadline,
            })}
          </div>
          {(dateText || (startDate && endDate)) &&
            (canPerformActions &&
            !(disabled || isSchoolCalendarEventActionsDisabled) ? (
              <RenderDatePickers
                updateStartDate={updateStartDate}
                updateEndDate={updateEndDate}
                startDateLocal={startDateLocal}
                endDateLocal={endDateLocal}
                itemType={itemType}
                showTimeSelector={showTimeSelector}
                isCurrentAcademicYear={isCurrentAcademicYear}
                calendarView={calendarView}
                isCalendarDeadlineView={isCalendarDeadlineView}
                disabled={disabled || isSchoolCalendarEventActionsDisabled}
                academicYearStartDate={academicYearStartDate}
                academicYearEndDate={academicYearEndDate}
                nextAcademicYearEndDate={nextAcademicYearEndDate}
                currentCurriculumProgramType={currentCurriculumProgramType}
                testId={testId}
                viewSource={viewSource}
                isFullDayEvent={isFullDayEvent}
                setLocalDateState={setLocalDateState}
              />
            ) : (
              <div
                className={classNames(
                  "text-body",
                  classes.dueTimeNonEditableText
                )}
              >
                {getEventDateTextMemoized({
                  start: startDate,
                  end: endDate,
                  rawStartDate,
                  rawEndDate,
                  isTimedEvent:
                    itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT &&
                    !isDeadlineAllDay,
                  isTimedSchoolCalendarEvent:
                    itemType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT &&
                    !isFullDayEvent,
                })}
              </div>
            ))}
        </div>
        {isRepeatEvent ? (
          <div className={classes.repeatEventContainer}>
            <div className={classNames("text-body", classes.summaryText)}>
              {repeatLabelText}
            </div>
          </div>
        ) : null}
        {isProjectTypeIAOrEA({ projectGroupType }) ? (
          <div className={classes.projectGroup}>
            <div className={classNames("text-label", classes.fieldText)}>
              {`${t("common:component")}`}
            </div>
            <div className={classNames("text-body", classes.fieldValue)}>
              {componentLabel}
            </div>
          </div>
        ) : null}
        {description ? (
          <>
            <div className={classes.label}>{t("common:description")}</div>
            <div className={classNames("text-body", classes.descriptionText)}>
              {getDescriptionForDisplay({
                description,
                showAllDescription: true,
                toggleItem: null,
                // 2DTODO: This most likely will be needed in future that's why keeping it here
                // toggleItem: (
                //   <DescriptionToggle
                //     t={t}
                //     showAllDescription={showAllDescription}
                //     setShowAllDescription={setShowAllDescription}
                //     testId={testId}
                //   />
                // ),
              })}
            </div>
          </>
        ) : null}
        {!_.isEmpty(attachments) ? (
          <div className={classes.attachment}>
            <div className={classes.label}>{`${t("common:attachments")}`}</div>
            <div className={classes.attachmentValue}>
              <AttachmentList
                dsVersion="2.0"
                name="attachments"
                value={attachments}
                attachmentMode={"view"}
                cardType="design-media-card"
                mediaCardSize={"small"}
                showCreateDropdown={false}
                showDeleteForSelfInViewMode={true}
                isShowIconsInBar={true}
                showV2Icons={true}
                isPrintEnabled={true}
                mode={"view"}
                showRenameAttachmentOption={false}
                attachmentContainerStyle={styles.attachmentContainerStyle}
              />
            </div>
          </div>
        ) : null}
        {location ? (
          <div className={classes.location}>
            <div className={classes.locationText}>
              {`${t("common:location")}`}
            </div>
            <div
              className={classNames("text-body", classes.locationValue)}
              dangerouslySetInnerHTML={{
                __html: getStyleStrippedText({
                  text: getStringAutoLinks(location),
                  type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                }),
              }}
            ></div>
          </div>
        ) : null}
        {gradeNames && !isNewEventCreationFlowFFEnabled && !isStaff ? (
          <CalendarWiseAssignedGrades
            t={t}
            gradeNamesList={gradeNamesList}
            filteredGrades={filteredGrades}
            isParent={isParent}
            testId={testId}
            isStaff={isStaff}
          />
        ) : null}
        {showNewEventParticipantList ? (
          <EventParticipantList
            associatedEntities={associatedEntities}
            sharedWith={sharedWith}
            isStaff={isStaff}
            users={eventDetails?.users}
            isAssociatedEntitiesDetailsLoading={
              isAssociatedEntitiesDetailsLoading
            }
            eventTitle={title}
            isEventDetailsLoading={isEventDetailsLoading}
            testId={`${testId}-participants`}
            eventType={itemType}
          />
        ) : null}
        {/* {!_.isEmpty(courseNames) && (
          <div className={classes.infoContainer}>
            <div className={classes.infoValue}>{courseNames}</div>
          </div>
        )} */}
        {isYearGroupVisible() && (
          <div className={classes.yearGroupContainer}>
            <div className={classNames("text-label", classes.fieldText)}>
              {`${t("common:year_group")}`}
            </div>
            <div className={classNames("text-body", classes.fieldValue)}>
              {yearGroupName}
            </div>
          </div>
        )}
        {!_.isNil(completedProjectsCount) || !_.isNil(pendingProjectsCount) ? (
          <SubmissionStatusWiseAssignedUsers
            t={t}
            submissionStatusStudentList={submissionStatusStudentList}
            defaultStudentNameOrderPreference={
              defaultStudentNameOrderPreference
            }
            testId={testId}
            turnedInCount={turnedInCount}
            isStudentSubmissionEnabled={isStudentSubmissionEnabled}
            title={title}
          />
        ) : null}
        {!isUserStaff &&
        itemType == MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT ? (
          <div className={classes.myProgressSection}>
            <div className={classes.title}>{t("common:progress")}</div>
            <div className={classes.text}>
              {t(isDeadlineCompleted ? "common:completed" : "common:pending")}
            </div>
          </div>
        ) : null}
      </div>

      <div className={classes.eventFooter}>
        <div className={classes.leftFooter}>
          <div className={classes.profile}>
            <Avatar
              shape={"square"}
              size={"medium"}
              name={name || ""}
              id={authorId || ""}
              src={profileImage || ""}
              dsVersion={"2.0"}
            />
            <div className={classes.nameContainer}>
              <div className={"text-body-s"}>
                {isUserStaff
                  ? t("common:created_by")
                  : itemType === MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT
                  ? t("classRoom:assigned_by")
                  : t("common:invited_by")}
              </div>
              <div className={"text-label"}>{assigneeName}</div>
            </div>
          </div>
        </div>
        {isQuickReschedule() ? (
          <DSProvider dsVersion="2.0">
            <EventUpdateConfirmationModal
              isOpen={isConfirmationModalOpen}
              onConfirm={onConfirmBtnClick}
              onClose={onCloseConfirmationModal}
              height="max-content"
              showCheckbox={!isProjectDeadlineModal}
              title={
                isProjectDeadlineModal
                  ? "common:update_deadline"
                  : "calendar:update_event"
              }
              confirmationMessage={
                isProjectDeadlineModal
                  ? "calendar:update_deadline_confirmation_message"
                  : "calendar:update_event_confirmation_message"
              }
            />
          </DSProvider>
        ) : null}

        {isViewTaskButtonVisible() || isQuickReschedule() ? (
          <div className={classes.rightFooter}>
            <Button
              variant={isQuickReschedule() ? "primary" : "progressive"}
              type={"fill"}
              size={"medium"}
              onClick={isQuickReschedule() ? clickHandler : onViewTaskBtnClick}
              style={{ zIndex: 1 }}
              testId={`${testId}-header-${buttonLabel}`}
              dsVersion={"2.0"}
              shortcut={{ code: "Enter", shiftKey: true }}
            >
              {buttonLabel}
            </Button>
          </div>
        ) : null}
      </div>

      {showNewDeadlineModalDetails?.displayModal ? getNewDeadlineModal() : null}

      {isVisible && (
        <EventCreationModal
          action={action}
          eventType={eventType}
          eventDetails={eventDetails}
          selectedTimeSlot={selectedTimeSlot}
          onCloseEventCreationModal={onCloseEventCreationModal}
          onCloseEventDetailsModal={onCloseEventDetailsModal}
          refetchEvents={refetchEvents}
          testId={`${testId}-eventCreationModal`}
        />
      )}

      <DSProvider dsVersion="2.0">
        <RecurrenceConfirmationModal
          actionRef={repeatEventModalActionRef}
          isOpen={false}
          eventTitle={eventDetails?.eventName || ""}
          title={t("calendar:edit_repeat_event")}
          onSave={onSaveRecurrenceHandler}
          onClose={onCloseConfirmationModal}
          isDateChanged={isEventDateChanged}
          isRecurringEventSettingsUpdated={false}
          updatedLabelText={updatedLabelText}
          showRepeatInfo={false}
        />
      </DSProvider>
      <Dialog
        isOpen={showDeleteDialogueBox}
        onClose={toggleDialogueBoxDisplay}
        title={DIALOGUES_INFO[itemType].title(t)}
        message={DIALOGUES_INFO[itemType].body({
          t,
          isEventCreatedByTheCurrentUser,
          name,
        })}
        buttonOneText={DIALOGUES_INFO[itemType].cancelButtonText(t)}
        buttonTwoText={DIALOGUES_INFO[itemType].confirmButtonText(t)}
        onButtonOneClick={toggleDialogueBoxDisplay}
        onButtonTwoClick={onDeleteConfirmClick}
        dsVersion={"2.0"}
      />
      {isLoading && <FullScreenLoader />}
    </div>
  );
};

const EventModalWithLoading = withLoader(EventDetails);

const EventDetailsComp = props => {
  const isInMobile = _.get(props, "isInMobile", false);
  const isEventDetailsLoading = !_.get(props, "isData", true); // when data is false, it means cache is empty it's initial loading
  const eventData = _.get(props, "eventData", {});
  if (isInMobile) {
    return <EventModalWithLoading {...props} />;
  }
  return (
    <div className={classes.modalContent}>
      {isEventDetailsLoading && _.isEmpty(eventData) ? (
        <EventDetailsLoader />
      ) : (
        <EventDetails {...props} />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const { isStudentProfileCalendarView, studentProfileId } = _.get(
    state,
    "myCalendar",
    {}
  );
  const { repeatScope } = _.get(state, "myCalendar.eventModal");

  const userInfo = _.get(state, "login.userInfo");
  const userId = isStudentProfileCalendarView ? studentProfileId : userInfo?.id;
  const userType = isStudentProfileCalendarView
    ? "student"
    : _.get(userInfo, "user_type");
  const orgId = _.get(userInfo, "org_id");
  const userEntityType = isStudentProfileCalendarView
    ? "STUDENT"
    : userInfo?.userEntityType;
  const selectedChildId = _.get(userInfo, "childID", "");
  const {
    currentCurriculumProgramType,
    currentCurriculumProgramId,
  } = getSelectedSchoolDetailsForCalendar(state);
  const isStaff = getIsStaff(state) && !isStudentProfileCalendarView;
  const isParent = getIsParent(state);
  const platform = _.get(state, "platform", {});
  const isCurriculumProgramFree = getCurriculumProgramFreeStatus({ state });
  const userCourseVariables = getUserCoursesVars({
    userInfo,
    platform,
    isCurriculumProgramFree,
  });

  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  const organizationCurriculumPrograms = getOrganizationCurriculumPrograms(
    state
  );

  const isStaffSchoolCalendarAdmin =
    !isStudentProfileCalendarView &&
    isStaffAdminForSchoolCalendarByContext({
      contexts: [
        {
          entityId: currentCurriculumProgramId,
          entityType: "CURRICULUM_PROGRAM",
        },
      ],
    });

  const projectGroupCategoryIdByType = getProjectGroupCategoryIdByType({
    curriculumProgramIds: currentCurriculumProgramId
      ? [currentCurriculumProgramId]
      : [],
    organizationId: orgId,
    curriculumType: currentCurriculumProgramType,
  });

  const isStaffProjectAdmin =
    isStaffAdminForProjectModules({
      projectGroupCategoryIdByType,
      curriculumProgramId: currentCurriculumProgramId,
    }) && !isStudentProfileCalendarView;
  const projectGroups = getProjectGroups(state, isStaffProjectAdmin);

  const showCalendarAssignmentByDueDate =
    getCalendarEventsViewSettingValue({
      organizationId: userInfo.org_id,
      currentCurriculumProgramId,
    }) === MY_CALENDAR_CONSTANTS.DUE_DATE;

  const selectedAcademicYear = getSelectedAcademicYearForSchool(state);
  const selectedAcademicYearStartDate = getSelectedAcademicYearStartDate({
    selectedAcademicYear,
  });
  const selectedAcademicYearEndDate = getSelectedAcademicYearEndDate({
    selectedAcademicYear,
  });
  const { isUpcomingAcademicYear } = selectedAcademicYear;
  const isNewEventCreationFlowFFEnabled = isNewEventCreationFlowEnabled();

  const calendarView = _.get(state, "myCalendar.calendarView");
  const isAgendaView = _.isEqual(calendarView, "agenda", true);

  return {
    orgId,
    userId,
    userType,
    userEntityType: isStudentProfileCalendarView
      ? "STUDENT"
      : userInfo?.userEntityType,
    selectedChildId,
    isUserParent: isParent,
    currentCurriculumProgramType,
    selectedViewOnlyTags: _.get(state, "myCalendar.selectedViewOnlyTags", []),
    defaultStudentNameOrderPreference,
    isAdmin: getIsAdminByRole() && !isStudentProfileCalendarView,
    projectGroups,
    showCalendarAssignmentByDueDate,
    currentCurriculumProgramId,
    isStaff,
    isParent,
    academicYearStartDate: selectedAcademicYearStartDate,
    academicYearEndDate: selectedAcademicYearEndDate,
    nextAcademicYearEndDate: getNextOrLastAcademicYearEndDate({
      organizationId: orgId,
    }),
    isUpcomingAcademicYear,
    projectGroupCategoryIdByType,
    isData: true,
    isLoading: false,
    isStudentProfileCalendarView,
    calendarUserType: userType,
    organizationId: orgId,
    academicYearId: _.get(selectedAcademicYear, "id", null),
    isStaffSchoolCalendarAdmin,
    userCourseVariables,
    skipAssociatedEntities: !isStaff || isStudentProfileCalendarView,
    repeatScope,
    isNewEventCreationFlowFFEnabled,
    organizationCurriculumPrograms,
    isAgendaView,
    isStaffUser: isUserTypeStaff({ userType }),
  };
};

const mapActionCreators = {
  deleteSchoolCalendarEvent,
  goToRelativeRoute,
  deleteDeadlineItem,
  setToastMsg,
  editSchoolCalendarEvent,
  updateDeadlineItem,
  getIsCurrentAcademicYear,
  updateNavigationObject,
  deleteDeadlineV2,
  updateDeadlineV2,
  updateEventModalV2,
};

EventDetails.propTypes = {
  dateText: PropTypes.string,
  onCloseClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onCopyClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  eventModal: PropTypes.object,
  refetchEvents: PropTypes.func,
  refetchRotationDays: PropTypes.func,
  deleteSchoolCalendarEvent: PropTypes.func,
  viewSource: PropTypes.string,
};

export default compose(
  I18nHOC({ resource: ["common", "project", "classRoom"] }),
  connect(mapStateToProps, mapActionCreators),
  getCalendarEventDetailsEnhancer(),
  graphql(getOrganizationDetailsQuery, {
    name: "getOrganizationDetails",
    skip: ({ isNewEventCreationFlowFFEnabled }) =>
      isNewEventCreationFlowFFEnabled,
    options: ({ orgId }) => ({
      variables: {
        id: orgId,
      },
    }),
    props: ({ getOrganizationDetails, ownProps: { isLoading, isData } }) => {
      const gradeList = _.get(getOrganizationDetails, "node.grades", []);
      const { networkStatus } = getOrganizationDetails;
      return {
        gradeList,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
        isData: !_.isEmpty(gradeList) && isData,
      };
    },
  }),
  graphql(getUserCoursesQuery, {
    name: "getUserCourses",
    skip: ({ eventData }) => {
      const eventType = _.get(eventData, "item.eventType", "");
      return eventType === MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT;
    },
    options: ({ userCourseVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: userCourseVariables,
      context: {
        useHttpLink: true,
      },
    }),
    props({ ownProps: { userCourseVariables } }) {
      const queryData = getUserCoursesFromCache(userCourseVariables);
      const allCourses = _.get(queryData, "courses", []);
      const userCoursesIds = _.map(allCourses, ({ id }) => id);
      return {
        userCoursesIds,
      };
    },
  }),
  graphql(getCalendarEventAssociatedEntitiesQuery, {
    name: "getCalendarEventAssociatedEntities",
    skip: ({ eventId, eventData, userType, isEventDetailsLoading }) => {
      if (!eventId || isEventDetailsLoading) return true;
      const associatedEntities = _.get(
        eventData,
        ["item", "associatedEntities"],
        []
      );
      const eventType = _.get(eventData, "item.eventType", "");
      const typeName = _.get(associatedEntities, "0.__typename", "");
      const participantListType = TYPENAME_MAPPING[typeName] || "CUSTOM";
      return (
        participantListType === "CUSTOM" ||
        eventType !== MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT ||
        userType !== "staff" ||
        (isNewParticipantSelectorEnabled() && isBigOrgFFEnabledAndStaffUser())
      );
    },
    options: ({ eventId, entityType = "PLATFORM_CALENDAR_EVENT" }) => ({
      variables: {
        id: eventId,
        type: entityType,
        associatedEntitiesFilters: {
          entityTypes: ["GRADE", "COURSE"],
        },
      },
    }),
    props: ({
      getCalendarEventAssociatedEntities,
      ownProps: { isLoading, isData },
    }) => {
      const associatedEntities = _.get(
        getCalendarEventAssociatedEntities,
        "node.item.associatedEntities",
        []
      );

      const typeName = _.get(associatedEntities, "0.__typename", "");
      const participantListType =
        TYPENAME_MAPPING[typeName] || ENTITY_TYPE_MAPPING.CUSTOM;
      const { networkStatus } = getCalendarEventAssociatedEntities;
      return {
        associatedEntities,
        participantListType,
        isAssociatedEntitiesDetailsLoading:
          _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  }),
  graphql(getCalendarEventAssociatedEntitiesQueryV2, {
    name: "getCalendarEventAssociatedEntities",
    skip: ({ eventId, eventData, userType, isEventDetailsLoading }) => {
      if (!eventId || isEventDetailsLoading) return true;
      const associatedEntities = _.get(
        eventData,
        ["item", "associatedEntities"],
        []
      );
      const eventType = _.get(eventData, "item.eventType", "");
      const typeName = _.get(associatedEntities, "0.__typename", "");
      const participantListType = TYPENAME_MAPPING[typeName] || "CUSTOM";
      return (
        participantListType === "CUSTOM" ||
        eventType !== MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT ||
        userType !== "staff" ||
        !isNewParticipantSelectorEnabled() ||
        !isBigOrgFFEnabledAndStaffUser()
      );
    },
    options: ({ eventId, entityType = "PLATFORM_CALENDAR_EVENT" }) => ({
      variables: {
        id: eventId,
        type: entityType,
        associatedEntitiesFilters: {
          entityTypes: ["GRADE", "COURSE"],
        },
      },
    }),
    props: ({
      getCalendarEventAssociatedEntities,
      ownProps: { isLoading, isData },
    }) => {
      const associatedEntities = _.get(
        getCalendarEventAssociatedEntities,
        "node.item.associatedEntities",
        []
      );

      const typeName = _.get(associatedEntities, "0.__typename", "");
      const participantListType =
        TYPENAME_MAPPING[typeName] || ENTITY_TYPE_MAPPING.CUSTOM;
      const { networkStatus } = getCalendarEventAssociatedEntities;
      return {
        associatedEntities,
        participantListType,
        isAssociatedEntitiesDetailsLoading:
          _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  })
)(EventDetailsComp);
